import { Link, useLocation } from '@tanstack/react-router';
import {
  BarChart3,
  Bell,
  Briefcase,
  CalendarClock,
  Columns3,
  FileText,
  LayoutDashboard,
  Settings,
  Users,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { NavItem as NavItemType } from '../../types/dashboard.types';

interface NavItemProps {
  item: NavItemType;
  isCollapsed?: boolean;
}

const iconMap: Record<string, typeof LayoutDashboard> = {
  'layout-dashboard': LayoutDashboard,
  'file-text': FileText,
  users: Users,
  'bar-chart-3': BarChart3,
  bell: Bell,
  settings: Settings,
  briefcase: Briefcase,
  'columns-3': Columns3,
  'calendar-clock': CalendarClock,
};

export function NavItem({ item, isCollapsed = false }: NavItemProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive =
    location.pathname === item.path ||
    (item.path !== '/dashboard' && location.pathname.startsWith(item.path));

  const Icon = iconMap[item.icon] || LayoutDashboard;
  const label = t(item.labelKey);

  return (
    <Link
      to={item.path}
      title={isCollapsed ? label : undefined}
      className={`flex w-full items-center rounded-lg text-sm font-medium transition-all duration-300 ${
        isCollapsed ? 'justify-center p-3' : 'gap-3 px-4 py-3'
      } ${
        isActive
          ? 'bg-accent-primary text-surface-inverse'
          : 'text-foreground-inverse hover:bg-white/10'
      }`}
    >
      <Icon className="h-5 w-5 shrink-0" />
      {!isCollapsed && <span>{label}</span>}
    </Link>
  );
}
